import { VisitaEstado } from '../../Visitas/consts/visitasStatus';
import { SiniestroItem, VisitaRoamItem } from '../types/siniestros.types';

// Última visita presentada del siniestro: la que se ve y de la que sale el acta (SMP-561)
export const getVisitaPresentada = (siniestro?: SiniestroItem | null): VisitaRoamItem | undefined =>
    (siniestro?.visitasRoam || [])
        .filter((visita) => visita.estadoId === VisitaEstado.PRESENTADO)
        .sort((a, b) => b.nro - a.nro)[0];
